const en_transHistory = {
    "": "Transaction History",

    title: {
        invoice_sales: "sales invoice",
        invoice_purch: "purchase invoice",
        penawaran: "quotation",
        out: "delivery order",
        in: "goods receipt",
        so: "sales order",
        po_sales: "incoming purchase order",
        po_purch: "outgoing purchase order",
        request: "item request",
    },

    label: {
        no_penawaran: "Quotation Number",
        no_data: "No data",
        no_so: "Sales Order Number",
        no_po_sales: "Incoming Purchase Order Number",
        no_po_purch: "Outgoing Purchase Order Number",
        no_in: "Delivery Order Reference Number",
        no_out: "Outgoing Delivery Order Reference Number",
        no_invoice_sales: "Sales Invoice Number",
        no_invoice_purch: "Purchase Invoice Number",
        no_request: "Item Request Number",
    }
}

export default en_transHistory;